module.exports = __webpack_public_path__ + "img/184.813c380b.jpg";